import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
  AddContractCaseDocumentParams,
  AddContractCaseDocumentResult,
  StartNewLeadParams,
  StartNewLeadResult,
} from '@/features/contractCases/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const contractCasesApi = createApi({
  reducerPath: 'contractCasesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/contract-cases',
  }),
  tagTypes: ['ContractCase'],
  endpoints: builder => ({
    startNewLead: builder.mutation<StartNewLeadResult, StartNewLeadParams>({
      query: data => ({
        url: '/new-lead',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['ContractCase'],
    }),
    addContractCaseDocument: builder.mutation<AddContractCaseDocumentResult, AddContractCaseDocumentParams>({
      query: ({ contractCaseId, file, documentType }) => {
        const formData = new FormData();
        formData.append('file', file);
        if (documentType !== undefined) formData.append('documentType', documentType);

        return {
          url: `/${contractCaseId}/documents`,
          method: 'POST',
          data: formData,
        };
      },
      invalidatesTags: ['ContractCase'],
    }),
  }),
});

export const {
  useStartNewLeadMutation,
  useAddContractCaseDocumentMutation,
} = contractCasesApi;
